import { ReactNode, memo } from 'react';

import { cn } from '@/lib/utils';

import { Badge, type BadgeProps } from '../../ui/badge';

type Props = {
  children: ReactNode;
  badgeContent?: boolean | ReactNode;
  className?: string;
  badgeProps?: BadgeProps;
};

export const NotificationBadge = memo(
  ({ children, badgeContent, className, badgeProps }: Props) => {
    const isDot = badgeContent === true;
    const showIndicator = badgeContent !== undefined && Boolean(badgeContent);

    return (
      <span className={cn('relative inline-flex', className)}>
        {children}
        {showIndicator && (
          <Badge
            type="default"
            flavour="destructive"
            rounded
            circular
            aria-hidden={isDot || undefined}
            {...badgeProps}
            className={cn(
              'absolute top-0 right-0 translate-x-1/2 -translate-y-1/2',
              badgeProps?.className
            )}
          >
            {isDot ? null : badgeContent}
          </Badge>
        )}
      </span>
    );
  }
);

NotificationBadge.displayName = 'NotificationBadge';
